import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./AboutDropDown.css";

const AboutDrawer = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const drawerRef = useRef(null);
  const [activeSection, setActiveSection] = useState(null);

  const aboutUsSections = [
    { title: "Who We Are", id: "who-we-are-section" },
    { title: "What We Do", id: "what-we-do-section" },
    { title: "Sourcing Methodology", id: "sourcing-methodology" },
    { title: "Vision, Mission, Values", id: "vision-mission-value-section" },
   
  ];


  useEffect(() => {
    const sectionIdFromHash = location.hash.replace("#", "");
    if (sectionIdFromHash) {
      setActiveSection(sectionIdFromHash);
      setTimeout(() => {
        const section = document.getElementById(`${sectionIdFromHash}2`);
        if (section) {
          const yOffset = -100; 
          const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100);
    } else {
      setActiveSection(null); 
    }
  }, [location.hash]);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);


  const handleClick = (id) => {
    navigate(`/about-us-section#${id}`);
    setActiveSection(id);
    setTimeout(() => {
      const section = document.getElementById(`${id}`);
      if (section) {
        const yOffset = -120;
        const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 100);
    onClose();
  };

  return (
    <div className="best-dropdown2">
      <div className={`product-drawer ${isOpen ? "open" : ""}`}>
        <div className="drawer-content" ref={drawerRef}>
          <button className="close-btn" onClick={onClose}>✖</button>

          <ul className="about-dropdown">
            {aboutUsSections.map((section) => (
              <li
                key={section.id}
                className={`category-item ${activeSection === section.id ? "open" : ""}`}
                onClick={() => handleClick(section.id)}
              >
                <div className="category-title">{section.title}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutDrawer;